import _ from 'lodash';
import platformUtils from '../../privates/platformUtils';
import monitoring from '../../privates/monitoring';

const publicPage = includePageId => (page = {}) => _.omitBy({
  name: page.name,
  type: page.type,
  url: page.url,
  applicationId: page.applicationId,
  prefix: page.prefix,
  isHomePage: page.isMainPage,
  id: includePageId ? page.id : undefined
}, (val, key) => _.isUndefined(val) || key === 'isHomePage' && !val);

const publicLightBox = (includePageId, includeType = false) => (lightbox = {}) => _.omitBy({
  name: lightbox.name,
  id: includePageId ? lightbox.id : undefined,
  type: includeType ? 'lightbox' : undefined
}, _.isUndefined);

const publicPrefix = (prefix = {}) => _.omitBy({
  name: prefix.name,
  prefix: prefix.prefix,
  type: prefix.type,
  applicationId: prefix.applicationId
}, _.isUndefined);

export default {
  getSiteStructure({ includePageId = false } = {}) {
    const RMI = platformUtils.getRMI('wix-site.getSiteStructure');
    const siteStructure = RMI.getSiteStructure();

    return {
      pages: (siteStructure.pages || []).map(publicPage(includePageId)),
      prefixes: (siteStructure.prefixes || []).map(publicPrefix),
      lightboxes: (siteStructure.lightboxes || []).map(publicLightBox(includePageId))
    };
  },
  getCurrentPage({ includePageId = false} = {}) {
    const RMI = platformUtils.getRMI();
    const contextId = platformUtils.getRGI().getContextId();
    const siteStructure = RMI.getSiteStructure();
    
    const page = _.find(siteStructure.pages, { id: contextId });
    if (page) {   
      return publicPage(includePageId)(page);
    }

    const lightbox = _.find(siteStructure.lightboxes, { id: contextId });
    if (lightbox) {
      return publicLightBox(includePageId, true)(lightbox);
    }

    monitoring.reportError(new Error(`No page nor lightbox was found for contextId: ${contextId}`));
    
    return null;
  }
};
